import { makeAutoObservable} from "mobx";
import { IUserResponseModel } from "../interfaces/responses/IUserResponseModel";

class UserStore {
    user: IUserResponseModel | null = null;
    isAuth = false;
    isAdmin = false;
    
    constructor() {
        makeAutoObservable(this);
    }
    
    setUser(user: IUserResponseModel | null) {
        this.user = user;
        this.isAuth = !!user;
        this.isAdmin = user?.role === 'ADMIN' || false;
    }
    
    login(user: IUserResponseModel) {
        this.setUser(user);
        localStorage.setItem('token', user.token || '');
    }
    
    logout() {
        this.setUser(null);
        localStorage.removeItem('token');
    }
}

export default UserStore;